var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"centerbox"}),_c('p',{staticClass:"describe",on:{"click":function($event){return _vm.cup()}}},[_vm._v(_vm._s(_vm.msg))]),_c('el-button',{staticStyle:{"margin-top":"30px","font-size":"23px","width":"120px"},attrs:{"type":"primary","plain":""},on:{"click":_vm.return_ick}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }